import i18next from 'i18next'
import { utils } from 'frontend-js-shared'

const PREDEFINED_DATE_RANGES = utils.dates.PREDEFINED_DATE_RANGES

export default {
  DATE_FILTER_OPTIONS: {
    all: 'all',
    custom: 'custom',
    last7Days: PREDEFINED_DATE_RANGES.last7Days,
    lastMonth: PREDEFINED_DATE_RANGES.lastMonth,
    last90Days: PREDEFINED_DATE_RANGES.last90Days,
    nextWeek: PREDEFINED_DATE_RANGES.nextWeek,
    thisWeek: PREDEFINED_DATE_RANGES.thisWeek,
    thisYear: PREDEFINED_DATE_RANGES.thisYear,
  },

  COMMON_DATE_OPTIONS: [
    {
      id: PREDEFINED_DATE_RANGES.last7Days,
      textKey: 'common.date_periods.last_week',
    },
    {
      id: PREDEFINED_DATE_RANGES.lastMonth,
      textKey: 'common.date_periods.last_month',
    },
    {
      id: PREDEFINED_DATE_RANGES.last90Days,
      textKey: 'common.date_periods.last_3_months',
    },
    {
      id: PREDEFINED_DATE_RANGES.thisYear,
      textKey: 'common.date_periods.last_12_months',
    },
    {
      id: 'custom',
      textKey: 'common.date_periods.custom',
    },
  ],

  DUE_DATE_OPTIONS: [
    {
      id: PREDEFINED_DATE_RANGES.thisWeek,
      textKey: 'common.date_periods.this_week',
    },
    {
      id: PREDEFINED_DATE_RANGES.nextWeek,
      textKey: 'common.date_periods.next_week',
    },
    {
      id: 'custom',
      textKey: 'common.date_periods.custom',
    },
  ],

  getRoleOptions() {
    return [
      {
        id: 'owner',
        text: i18next.t('filters.role_options.owner'),
      },
      {
        id: 'coach',
        text: i18next.t('filters.role_options.coach'),
      },
      {
        id: 'collaborators',
        text: i18next.t('filters.role_options.collaborators'),
      },
    ]
  },

  getPriorityOptions() {
    return [
      {
        id: 'high',
        text: i18next.t('priority.high'),
      },
      {
        id: 'medium',
        text: i18next.t('priority.medium'),
      },
      {
        id: 'low',
        text: i18next.t('priority.low'),
      },
    ]
  },

  getConditionOptions() {
    return [
      {
        id: 'isApproved',
        text: i18next.t('filters.condition_options.approved'),
      },
      {
        id: 'isHighlighted',
        text: i18next.t('filters.condition_options.highlighted'),
      },
      {
        id: 'isRevFromFinding',
        text: i18next.t('filters.condition_options.isRevFromFinding'),
      },
      {
        id: 'isNotRevFromFinding',
        text: i18next.t('filters.condition_options.isNotRevFromFinding'),
      },
      {
        id: 'isReplica',
        text: i18next.t('filters.condition_options.isReplica'),
      },
      {
        id: 'hasReplica',
        text: i18next.t('filters.condition_options.hasReplica'),
      },
    ]
  },

  getValidationOptions() {
    return {
      notImplemented: {
        id: 'notImplemented',
        text: i18next.t('filters.validation_options.not_implemented'),
      },
      implemented: {
        id: 'implemented',
        text: i18next.t('filters.validation_options.implemented'),
      },
      impactNotValidated: {
        id: 'impactNotValidated',
        text: i18next.t('filters.validation_options.impact_not_validated'),
      },
      impactValidated: {
        id: 'impactValidated',
        text: i18next.t('filters.validation_options.impact_validated'),
      },
    }
  },

  getRoutineTypeOptions() {
    return [
      {
        id: '5s_audit',
        text: i18next.t('filters.routine_type_options.5s_audit'),
      },
      {
        id: 'maintenance',
        text: i18next.t('filters.routine_type_options.maintenance'),
      },
      {
        id: 'gemba',
        text: i18next.t('filters.routine_type_options.gemba'),
      },
      {
        id: 'quality_control',
        text: i18next.t('filters.routine_type_options.quality_control'),
      },
      {
        id: 'communication',
        text: i18next.t('filters.routine_type_options.communication'),
      },
      {
        id: 'financial_tracking',
        text: i18next.t('filters.routine_type_options.financial_tracking'),
      },
    ]
  },
}
